export const extractOfferIdsFromOrder = (order: App.Order) => {
  if (!order) {
    return []
  }

  return [
    ...order.items.map((i) => i.offerId),
    ...order.bedbankItems.map((i) => i.offer.id),
    ...order.tourItems.map((i) => i.tourId),
  ]
}
